import logService from '../../../../services/wss/logService3';
import userTopicService from '../../../../services/UserTopicService';

const _name = 'TopicGroupSearchFetcher';

/**
 * Fetches search results scoped to a service via the shared search endpoint.
 * Client-side filters on service — API has no scope param.
 */
export default class TopicGroupSearchFetcher {
    /**
     * @param {string} query - Min 3 chars
     * @param {string} service - TopicGroup service name to filter on
     * @returns {object[]} Filtered items or []
     */
    search = async (query, service) => {
        try {
            const resp = await userTopicService.search({ q: query, page: 1, size: 50 });
            if (resp === -1) return [];

            const items = resp.data?.items ?? [];
            return items;
            // return items.filter((i) => i.service === service);
        } catch (error) {
            logService.logError(`${_name}.search: ${error.message}`);
            return [];
        }
    };
}
